document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('header');

  if (header) {
    const observer = new MutationObserver((mutations) => {
      const anyActive = !!document.querySelector('.modal.is-active[data-modal]');
      header.style.zIndex = anyActive ? '0' : '';
    });

    document.querySelectorAll('.modal[data-modal]').forEach((modal) => {
      observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
    });
  }

  document.querySelectorAll('.navigation__item a[href]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.stopPropagation();
      window.location.href = link.href;
    });
  });

})

class AddCartPanel extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this._onVariantChange.bind(this));
  }

  _onVariantChange(e) {
    if (e.target.name !== 'id') return;
    const label = this.querySelector(`label[for="${e.target.id}"]`);
    if (label && label.dataset.price) {
      this.querySelectorAll('[data-product-price]').forEach(el => {
        el.textContent = label.dataset.price;
      });
    }
    this._swapCardImage(parseInt(e.target.value, 10));
  }

  // Collection card: show the active variant's media when its volume is toggled.
  // Swaps the full media HTML (image or video, either direction) and restarts
  // any lazy-autoplay video, leaving the GSAP-parallaxed wrapper element alive.
  _swapCardImage(variantId) {
    const card = this.closest('[data-product-card]');
    if (!card) return; // sticky panel etc. — no card to swap
    const dataEl = card.querySelector('[data-card-variants]');
    const wrapper = card.querySelector('[data-card-image]');
    if (!dataEl || !wrapper) return;
    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (_) { return; }
    const match = variants.find(v => v.id === variantId);
    if (!match) return;

    if (match.html) this._swapMedia(wrapper, match.html);
    if (match.preview) {
      const preview = card.querySelector('[data-card-preview]');
      if (preview) this._swapMedia(preview, match.preview);
    }
  }

  _swapMedia(el, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    // Same media as what's already there (e.g. one shared video across variants)?
    // Leave it untouched so the video keeps playing instead of blinking/restarting.
    const currentKey = this._mediaKey(el);
    if (currentKey && currentKey === this._mediaKey(doc)) return;

    el.innerHTML = html;
    el.querySelectorAll('video[data-video-lazy-autoplay]').forEach(v => {
      const source = v.querySelector('source');
      if (source && !source.src && source.dataset.src) {
        source.src = source.dataset.src;
        v.load();
      }
      v.play().catch(() => {});
    });
  }

  // Identity of a media block: video source URL or image URL (query stripped).
  _mediaKey(root) {
    const source = root.querySelector('source');
    if (source) return (source.getAttribute('data-src') || source.getAttribute('src') || '').split('?')[0];
    const img = root.querySelector('img');
    if (img) return (img.getAttribute('src') || '').split('?')[0];
    return '';
  }
}

if (!customElements.get('add-cart-panel')) {
  customElements.define('add-cart-panel', AddCartPanel);
}